<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/NSMlKw/tc-custom/9781473816923.jpg?1701061265482" alt="This image is the cover for the book One of Our Submarines, Pen & Sword Military Classics"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">One of Our Submarines, Pen & Sword Military Classics
      </h1>
      <p class="bookDescription body article font2">
        <b>“[Young] </b><b>immortalized his distinguished war service as a submariner in the bestselling autobiography, <i>One of Our Submarines</i> . . . [a] gripping memoir.”—<i>The Guardian</i></b><br/>  <br/> “In the very highest rank of books about the last war. Submarines are thrilling beasts, and Edward Young tells of four years’ adventures in them in a good stout book with excitement on every page. He writes beautifully, economically and with humor, and in the actions he commands he manages to put the reader at the voice-pipe and the periscope so that sometimes the tension is so great that one has to put the book down.”—<i>The Sunday Times</i><br/>  <br/> “No disrespect to the big screen, but you can’t beat a book for digging out the details. And the details feel even better if the author is someone who’s been there. So, at least take the time to read <i>Das Boot</i>, the autobiographical novel by Lothar-Günther Buchheim. And, for the British perspective, read <i>One of Our Submarines</i> by Edward Young.”—The Mouldy Books<br/>  <br/> “He tells his story in a modest, clear, and amusing way that is a delight to read.”—not too much
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Edward Young
      </h2>
      
      <p class="authorDescription body article">Edward Young developed an interest in the Meiktila campaign whilst writing his book Air Commando Fighters of World War II. Previous work includes Aerial Nationalism: A History of Aviation in Thailand (Smithsonian Institution, 1995). He has also contributed to numerous British and American aviation magazines. Edward is by profession a financial analyst in New York City and lives with his family in New Jersey.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Pen & Sword Military Classics
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?902898f2